import React, { useEffect, useContext, useState, useActionState } from 'react';
import { useLocation } from 'react-router-dom';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Input_Time from '../ERUMAUI/UI_Input_Time';
import UI_Input_Date from '../ERUMAUI/UI_Input_Date';
import UI_Input_Text_Long from '../ERUMAUI/UI_Input_Text_Long';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import UI_Button from '../ERUMAUI/UI_Button';
import { useAuth } from '../../Contexts/AuthContext';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import { useStatus } from '../../Contexts/Context_Status_Global';
import UI_Card from '../ERUMAUI/UI_Card';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_UpdatingStatus from '../ERUMAUI/UI_UpdatingStatus';
import { useAccounts } from '../../Contexts/Context_Accounts';
import Controls_Map_Selector from '../InteractiveMap/Controls_Map_Selector';
import UI_Toggle from '../ERUMAUI/UI_Toggle';
import UI_StatGroup from '../ERUMAUI/UI_StatGroup';

export default function Subwindow_ScheduleManagement_Reserve({ zIndex, isActive, id }) {
    const UI = useContext(Context_UI);
    const { Account } = useAuth();
    const { User_Role, User } = useAccounts();
    const { List_Unsaved, List_Unsaved_Set, Status_Saving, Unsaved_Clear, Confirmer_Confirm } = useStatus();
    const { Template_List } = useTemplating();
    const { Buildings, Floors, Rooms, Map_Composition, Room_Find, Room_Highlight, Get_Parent_Index, Map_Information, Map_Information_Type, Map_Information_Set, Map_Information_Type_Set, Map_Time_Parameters, Map_Time_Parameters_Update, Information_Display } = useMapRenderer();
    const { Reservation, Reservation_Set, Reservation_Save, Reservation_Step, Reservation_Step_Set, Reservation_Clear, Conflicts, Time_Range_Parse, Status_Parse, Conflict_Recommendation, Time_Parse, Conflict_Recommendation_Get } = useScheduleManagement();
    const Location = useLocation();
    const Parameters = new URLSearchParams(Location.search);
    const Parameter_Room = Parameters.get('rm');

    useEffect(() => {
        if (Account?.Name_Compounded) {
            Reservation_Set(Previous => ({
                ...Previous,
                Requester: {
                    ...Previous.Requester,
                    Name: Account.Name_Compounded,
                    Email: Account.Email,
                    Type: User_Role,
                    RequesterID: Account._id,
                }
            }))
        }
        if (Parameter_Room) {
            Reservation_Set(Previous => ({
                ...Previous,
                RoomID: Parameter_Room
            }))
        }
    }, [Account]);

    useEffect(() => {
        if (!List_Unsaved.includes("Create Reservation")) {
            List_Unsaved_Set(prev => [...prev, "Create Reservation"]);
        }
    }, [])

    useEffect(() => {
        const Handler = ({ List_ID, Value }) => {
            switch (List_ID) {
                case "Activity_Type":
                    Handle_Change(["Activity", "Type"], Value);
                    break;
                case "Activity_Requester_Type":
                    Handle_Change(["Requester", "Type"], Value);
                    break;
                case "Activity_Subject":
                    Handle_Change(["Activity", "Subject"], Value);
                    break;
            }
        }

        UI.on("Dropdown_Value_Submitted", Handler);
        return () => {
            UI.off("Dropdown_Value_Submitted", Handler);
        }
    }, [UI]);

    const Close = async () => {
        if (await Unsaved_Clear("Create Reservation")) {
            Reservation_Clear();
            UI.Subwindows_Close(id);
        }
    }

    const Handle_Change = (Keys, Value) => {
        const Update = (Previous, Keys, Value) => {
            if (Keys.length === 1) {
                return { ...Previous, [Keys[0]]: Value };
            }
            const [Key_Current, ...Keys_Rest] = Keys;
            return {
                ...Previous,
                [Key_Current]: Update(Previous[Key_Current], Keys_Rest, Value)
            };
        }
        Reservation_Set(Previous => Update(Previous, Keys, Value));
    }

    const Get_Value = (Object, Keys) => {
        if (!Object) { return "" };
        let Current = Object;
        for (const Key of Keys) {
            if (Current === undefined || Current === null) { return "" };
            Current = Current[Key];
        }
        return Current;
    }

    const Handle_Step = async (Direction) => {
        switch (Reservation_Step) {
            case "Tab_Info_Request":
                if (Direction == "Forward") {
                    const Cleared = await UI.Input_Evaluate([
                        {
                            Type: "Text",
                            ID: "Activity_Name",
                            AC: "",
                            Prompt: "This field is required."
                        },
                        {
                            Type: "Dropdown",
                            ID: "Activity_Type",
                            AC: "No activity type selected",
                            Prompt: "This field is required."
                        },
                        {
                            Type: "Text",
                            ID: "Activity_Requester_Name",
                            AC: "",
                            Prompt: "This field is required."
                        },
                        {
                            Type: "Text",
                            ID: "Activity_Requester_Email",
                            AC: "",
                            Prompt: "This field is required."
                        },
                        {
                            Type: "Text",
                            ID: "Activity_Requester_Type",
                            AC: "",
                            Prompt: "This field is required."
                        },
                    ]);
                    if (Cleared) {
                        Reservation_Step_Set("Tab_Info_Schedule");
                    }
                }
                break;
            case "Tab_Info_Schedule":
                if (Direction == "Backward") {
                    Reservation_Step_Set("Tab_Info_Request");
                }
                if (Direction == "Forward") {
                    const Cleared = await UI.Input_Evaluate([
                        {
                            Type: "Time_Range_Custom",
                            ID_Start: "Schedule_Start",
                            ID_End: "Schedule_End",
                            AC: "",
                            Prompt: "Invalid time range."
                        },
                        {
                            Type: "Date",
                            ID: "Schedule_Date",
                            AC: "Past",
                            Prompt: "The date cannot be set to the past."
                        }
                    ]);
                    if (Cleared) {
                        Reservation_Step_Set("Tab_Info_Finalize");
                    }

                }
                break;
            case "Tab_Info_Finalize":
                if (Direction == "Backward") {
                    Reservation_Step_Set("Tab_Info_Schedule");
                }
                if (Direction == "Forward") {
                    Reservation_Step_Set("Tab_Info_Send");
                    Reservation_Save();
                    // console.log(Reservation);
                }
                break;
        }
    }

    const [Working_Buildings, Working_Buildings_Set] = useState([]);
    const [Working_Floors, Working_Floors_Set] = useState([]);
    const [Working_Rooms, Working_Rooms_Set] = useState([]);
    const [SelectedLabels, SelectedLabels_Set] = useState({
        building: 0,
        floor: 0,
        room: 0,
    });
    useEffect(() => {
        const Handle = ({ List_ID, Value, Value_Index }) => {
            switch (List_ID) {
                case "Schedule_Building": {
                    const b = Map_Composition[Value_Index];
                    if (!b) return;
                    // cascade arrays
                    Working_Floors_Set(b.Floors || []);
                    Working_Rooms_Set([]);
                    // update labels
                    SelectedLabels_Set({ building: b.Name, floor: null, room: null });
                    // clear room selection in reservation
                    Reservation_Set(prev => ({ ...prev, RoomID: "" }));
                    break;
                }
                case "Schedule_Floor": {
                    const f = Working_Floors[Value_Index];
                    if (!f) return;
                    Working_Rooms_Set(f.Rooms || []);
                    SelectedLabels_Set(prev => ({ ...prev, floor: f.Name, room: null }));
                    Reservation_Set(prev => ({ ...prev, RoomID: "" }));
                    break;
                }
                case "Schedule_Room": {
                    const r = Working_Rooms[Value_Index];
                    if (!r) return;
                    SelectedLabels_Set(prev => ({ ...prev, room: r.Name }));
                    Reservation_Set(prev => ({ ...prev, RoomID: r._id }));
                    // optional: mirror on the map
                    // Room_Highlight(r._id, 1.6, 400, "Directory");
                    break;
                }
                default:
                    break;
            }
        };

        UI.on("Dropdown_Value_Submitted", Handle);
        return () => UI.off("Dropdown_Value_Submitted", Handle);
    }, [UI, Map_Composition, Working_Floors, Working_Rooms, Reservation_Set, Reservation]);

    useEffect(() => {
        if (Map_Information_Type === "Room" && Map_Information) {
            Reservation_Set(prev => ({ ...prev, RoomID: Map_Information._id }));
        }
        if (!Map_Information?.Restrictions?.hasAirconditioner) {
            Reservation_Set(prev => ({ ...prev, Request_Airconditioner: false }));
        }
    }, [Map_Information, Map_Information_Type]);

    useEffect(() => {
        const Handle_Toggle_Airconditioning = ({ ID, State }) => {
            if (ID === "Request_Aircon") {
                if (State === "Active") {
                    Reservation_Set(prev => ({ ...prev, Request_Airconditioner: true }));
                } else {
                    Reservation_Set(prev => ({ ...prev, Request_Airconditioner: false }));
                }
            }
        }

        UI.on("Button_Toggled", Handle_Toggle_Airconditioning);
        return () => {
            UI.off("Button_Toggled", Handle_Toggle_Airconditioning);
        }
    })

    useEffect(() => {
        const Structure = Get_Parent_Index(Reservation.RoomID);
        if (!Structure) return;

        SelectedLabels_Set(prev => ({
            ...prev,
            building: Map_Composition[Structure.Index_Building].Name,
            floor: Map_Composition[Structure.Index_Building]?.Floors[Structure.Index_Floor].Name || null,
            room: Map_Composition[Structure.Index_Building].Floors[Structure.Index_Floor].Rooms[Structure.Index_Room].Name
        }));

        Working_Floors_Set(Map_Composition[Structure.Index_Building]?.Floors);
        Working_Rooms_Set(Map_Composition[Structure.Index_Building]?.Floors[Structure.Index_Floor].Rooms);
    }, [Reservation.RoomID, Map_Composition]);

    useEffect(() => {
        if (Reservation.RoomID) {
            Conflict_Recommendation_Get();
        }

    }, [Reservation.RoomID]);




    const Handle_Time_Change = async (e) => {
        const { id, value } = e.target;

        Reservation_Set((prev) => {
            let newStart = new Date(prev.Time.Start);
            let newEnd = new Date(prev.Time.End);

            if (id === "Schedule_Date") {
                // Update both Start & End with new date, preserve hours/minutes
                const [year, month, day] = value.split("-").map(Number);
                newStart.setFullYear(year, month - 1, day);
                newEnd.setFullYear(year, month - 1, day);
                Map_Time_Parameters_Update("Date", value);
            }

            if (id === "Schedule_Start") {
                const [hours, minutes] = value.split(":").map(Number);
                newStart.setHours(hours, minutes, 0, 0);
                Map_Time_Parameters_Update("Time_Start", value);
            }

            if (id === "Schedule_End") {
                const [hours, minutes] = value.split(":").map(Number);
                newEnd.setHours(hours, minutes, 0, 0);
                Map_Time_Parameters_Update("Time_End", value);
            }

            return {
                ...prev,
                Time: {
                    Start: newStart,
                    End: newEnd,
                },
                DateModified: new Date()
            };
        });
        // await Conflict_Check();
    };


    const Format_Time = (date, Type) => {
        if (!(date instanceof Date) || isNaN(date)) return "";
        const pad = (n) => String(n).padStart(2, "0");
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());

        switch (Type) {
            case "date":
                return `${year}-${month}-${day}`;
            case "time":
                return `${hours}:${minutes}`;
            case "datetime-local":
                return `${year}-${month}-${day}T${hours}:${minutes}`;
            default:
                return "";
        }
    }

    const Format_Location = () => {
        // console.log(SelectedLabels);
        return `${SelectedLabels.building}, ${SelectedLabels.floor}, ${SelectedLabels.room}`;
    }

    function Format_TimeRange(start, end) {
        const opts = { hour: "numeric", minute: "2-digit", hour12: true };
        return `${start.toLocaleTimeString([], opts)} - ${end.toLocaleTimeString([], opts)}`;
    }

    function Format_Date(date) {
        const opts = { weekday: "short", year: "numeric", month: "long", day: "2-digit" };
        return date.toLocaleDateString(undefined, opts);
    }

    const Handle_Map = async () => {
        const { Response, Data } = await Confirmer_Confirm('Window_Map_ChooseRoom');
        if (Response === "Confirmed") {
            // console.log(Data.RoomID);
        }
    }


    const Suggestion_Accept = (Data, Type) => {
        if (Type === "Time") {
            const Start = new Date(Data.Start);
            const End = new Date(Data.End);

            // Reservation_Changeable_Set({
            //     Start,
            //     End,
            //     Date: Start
            // });
            Reservation_Set(prev => ({ ...prev, Time: { Start, End }, Date: Start }));
        }
        if (Type === "Room") {
            // console.log(Data);
            Map_Information_Type_Set("Room");
            Map_Information_Set(Data);
            Information_Display(Data._id);
            // Reservation_Set(prev => ({ ...prev, RoomID: Data._id }));
        }
    };

    const [Conflicts_BlockedHours, Conflicts_BlockedHours_Set] = useState([]);
    const [Conflicts_Soft, Conflicts_Soft_Set] = useState([]);
    useEffect(() => {
        if (Conflicts.Soft.length > 0) {
            Conflicts_BlockedHours_Set(Conflicts.Soft.filter(Item => Item.BlockedHours));
            Conflicts_Soft_Set(Conflicts.Soft.filter(Item => !Item.BlockedHours));
        }
    }, [Conflicts])

    const [Room_BlockedHours, Room_BlockedHours_Set] = useState(null);
    useEffect(() => {
        console.warn(Map_Information);
        console.warn(Map_Information_Type);
        console.warn(Map_Information?.Restrictions?.hasBlockedHours);

        if (Map_Information && Map_Information_Type === "Room" && Map_Information.Restrictions.hasBlockedHours) {
            const Day_Current = new Date(Map_Time_Parameters.Date).getDay();
            const Room_Restrictions = Map_Information.Restrictions.BlockedHours[Day_Current];
            console.warn(Room_Restrictions);

            if (Room_Restrictions.Block) {
                Room_BlockedHours_Set({
                    Start: Room_Restrictions.Start,
                    End: Room_Restrictions.End
                })
            } else {
                Room_BlockedHours_Set(null)
            }
        } else {
            Room_BlockedHours_Set(null);
        }
    }, [Map_Information, Map_Time_Parameters]);

    useEffect(() => {
        console.warn(Room_BlockedHours);
    }, [Room_BlockedHours, Map_Information]);

    return (
        <ui-subwindow Type='Subwindow' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    Create a reservation
                </h2>
                {/* <button className='Subwindow_TitleBar_Control' onClick={Close}>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button> */}
            </ui-subwindow-titlebar>
            <ui-subwindow-content style={{ minHeight: "700px", paddingRight: "10px" }}>
                <UI_Horizontal_Tabs
                    Clickable={false}
                    id="Reservation_Tabs"
                    Selectors={[
                        {
                            Text: "Step 1: Request information",
                            Icon: <UI_Icon Name="User_Edit" />
                        },
                        {
                            Text: "Step 2: Schedule information",
                            Icon: <UI_Icon Name="Schedule" />
                        },
                        {
                            Text: "Step 3: Finalize request",
                            Icon: <UI_Icon Name="Finish" />
                        },
                        {
                            Text: "Step 4: Send request",
                            Icon: <UI_Icon Name="Send" />
                        }
                    ]}
                    Selected={Reservation_Step}
                    UIDs={[
                        "Info_Request",
                        "Info_Schedule",
                        "Info_Finalize",
                        "Info_Send"
                    ]}
                    Components={[
                        <>
                            <h3 className='General_Paragraph'>
                                Please specify the nature of your reservation.
                            </h3>
                            <div className='General_Split' Split="2">
                                <UI_Form Composition="ByTwo">
                                    {/* <span></span> */}
                                    {/* <h3 className="General_Paragraph">
                                        Required fields
                                    </h3> */}
                                    <UI_Input_Text
                                        id="Activity_Name"
                                        Input_Placeholder="Name of the activity"
                                        Label_Text="Activity name:"
                                        Value_Set_Enable={true}
                                        Value={Reservation.Name}
                                        onChange={(e) => Handle_Change(["Name"], e.target.value)}
                                        Required={true}
                                    />
                                    <UI_Input_Text_Long
                                        id="Activity_Description"
                                        Input_Placeholder="A brief description of the activity"
                                        Label_Text="Description:"
                                        Autoresize="true"
                                        Value_Set_Enable={true}
                                        Value={Reservation.Description}
                                        onChange={(e) => Handle_Change(["Description"], e.target.value)}
                                    />
                                    <UI_Dropdown
                                        id="Activity_Type"
                                        Label_Text="Activity type:"
                                        InitialTitle="Activity type"
                                        Selected={Reservation.Activity?.Type}
                                        Items={Template_List.Activity?.Type} Fill
                                        Required={true}
                                    />
                                    <UI_Input_Text
                                        id="Activity_Requester_Name"
                                        Input_Placeholder="Name of the requester"
                                        Label_Text="Requester name:"
                                        Value_Set_Enable={true}
                                        Value={Reservation.Requester.Name}
                                        disabled={true} />
                                    <UI_Input_Text
                                        id="Activity_Requester_Email"
                                        Input_Placeholder="Email of the requester"
                                        Type="email"
                                        Label_Text="Requester email:"
                                        Value_Set_Enable={true}
                                        Value={Reservation.Requester.Email}
                                        disabled={true} />
                                    <UI_Input_Text
                                        id="Activity_Requester_Type"
                                        Input_Placeholder="Email of the requester"
                                        Type="email"
                                        Label_Text="Requester type:"
                                        Value_Set_Enable={true}
                                        Value={Reservation.Requester.Type}
                                        disabled={true} />
                                    {/* <UI_Dropdown
                                        id="Activity_Requester_Type"
                                        Label_Text="Requester type:"
                                        InitialTitle={Reservation.Requester.Type}
                                        Selected={Reservation.Requester.Type}
                                        Items={Template_List.RequesterType} Fill
                                        Required={true}
                                    /> */}

                                </UI_Form>
                                <UI_Form Composition="ByTwo">
                                    {/* <UI_Input_Text
                                    Label_Text="Attendees:" /> */}
                                    {/* <span></span> */}
                                    {/* <h3 className="General_Paragraph">
                                        Optional fields
                                    </h3> */}
                                    <UI_Dropdown
                                        id="Activity_Subject"
                                        Label_Text="Subject:"
                                        InitialTitle="Subject"
                                        Selected={Reservation.Activity.Subject}
                                        Items={Template_List.Activity?.Subject} Fill />
                                    <label className='Input_Label'>
                                        Attendees:
                                    </label>
                                    <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: "10px", alignItems: "center" }}>
                                        <p className='General_Paragraph'>
                                            <b>
                                                {Reservation.Activity.Attendees.Names.length === 0 ?
                                                    "No attendees set"
                                                    :
                                                    Reservation.Activity.Attendees.Names.length === 1 ?
                                                        `${Reservation.Activity.Attendees.Names[0]}`
                                                        :
                                                        `${Reservation.Activity.Attendees.Names[0]} + ${Reservation.Activity.Attendees.Names.length - 1} others`
                                                }
                                                {/* Soshiro Hoshina + 31 others */}
                                            </b>
                                        </p>
                                        <UI_Button
                                            Submit={false}
                                            Text="Edit"
                                            Icon={<UI_Icon Name="Add" />}
                                            Icon_Position="Center"
                                            OnClick={() => UI.Subwindows_Open("Window_ScheduleManagement_Attendees")}
                                        />
                                    </div>
                                    <label className='Input_Label'>
                                        Equipment:
                                    </label>
                                    <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: "10px", alignItems: "center" }}>
                                        <p className='General_Paragraph'>
                                            <b>
                                                {Reservation.Equipment.length === 0 ?
                                                    "No equipments set"
                                                    :
                                                    Reservation.Equipment.length === 1 ?
                                                        `${Reservation.Equipment[0]}`
                                                        :
                                                        `${Reservation.Equipment[0]} + ${Reservation.Equipment.length - 1} others`
                                                }
                                                {/* Projector + 2 others */}
                                            </b>
                                        </p>
                                        <UI_Button
                                            Submit={false}
                                            Text="Edit"
                                            Icon={<UI_Icon Name="Add" />}
                                            Icon_Position="Center"
                                            OnClick={() => UI.Subwindows_Open("Window_ScheduleManagement_Equipment")}
                                        />
                                    </div>
                                    {/* <UI_Dropdown
                                    id="Activity_Equipment"
                                    Input_Placeholder="Equipments"
                                    Label_Text="Equipment:"
                                    InitialTitle="Pick equipment"
                                    Items={Template_List.Equipment} Fill /> */}
                                    {/* <UI_Input_Text_Long
                                        id="Activity_Remarks"
                                        Input_Placeholder="Additional remarks"
                                        Label_Text="Additional remarks:"
                                        Autoresize="true"
                                        Value_Set_Enable={true}
                                        Value={Reservation.Remarks}
                                        onChange={(e) => Handle_Change(["Remarks"], e.target.value)} /> */}
                                </UI_Form>
                            </div>


                        </>,
                        <>
                            <h3 className='General_Paragraph'>
                                Please select a room and schedule for your reservation.
                            </h3>
                            <div className='General_Split' Split="3">
                                <div>
                                    <UI_Divider Text="Location" />
                                    <div style={{ marginBottom: "10px" }}>
                                        <Controls_Map_Selector
                                            Composition={Map_Composition}
                                            Room_Show={true}
                                            Room_Selectable={true}
                                            NoTime={true}
                                            Labels={true}
                                            Direction="Column"
                                            Form={true}
                                            Absolute={false}
                                            Required={true}
                                        />
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <UI_Button
                                            Icon={<UI_Icon Name="Map" />}
                                            Icon_Position="Left"
                                            Text="Choose from the interactive map"
                                            OnClick={Handle_Map}
                                        />
                                        <UI_StatGroup
                                            Items={[
                                                {
                                                    Key: "Capacity",
                                                    Value: Map_Information?.Capacity,
                                                    Color: "Gray"
                                                },
                                                {
                                                    Key: "Airconditioning",
                                                    Value: Map_Information?.Restrictions?.hasAirconditioner ? "Available" : "Unavailable",
                                                    Color: Map_Information?.Restrictions?.hasAirconditioner ? "Green" : "Red"
                                                },

                                                {
                                                    Key: "Class hours",
                                                    Value: Room_BlockedHours ? Time_Range_Parse(Room_BlockedHours?.Start, Room_BlockedHours?.End, "Time") : "None",
                                                    Color: Room_BlockedHours ? "Orange" : "Green"
                                                }
                                            ]}
                                        />
                                        {Map_Information?.Restrictions?.hasAirconditioner ?
                                            <div style={{ display: "none" }}>
                                                <UI_Toggle
                                                    id="Request_Aircon"
                                                    Text="Add airconditioner to request"
                                                />
                                            </div>
                                            :
                                            ""
                                        }
                                    </div>
                                    <UI_Divider Text="Schedule" />
                                    <UI_Form Composition="ByTwo">
                                        <UI_Input_Time
                                            id="Schedule_Start"
                                            Label_Text="Start time:"
                                            Value={Format_Time(Reservation.Time.Start, "time")}
                                            onChange={Handle_Time_Change}
                                            Required={true}
                                        />
                                        <UI_Input_Time
                                            id="Schedule_End"
                                            Label_Text="End time:"
                                            Value={Format_Time(Reservation.Time.End, "time")}
                                            onChange={Handle_Time_Change}
                                            Required={true}
                                        />
                                        {/* <UI_Input_Text
                                            id="Schedule_Start"
                                            Label_Text="Start time:"
                                            Input_Type='time'
                                            Value_Set_Enable={true}
                                            Value={Format_Time(Reservation.Time.Start, "time")}
                                            onChange={Handle_Time_Change}
                                            Required={true}
                                        /> */}
                                        {/* <UI_Input_Text
                                            id="Schedule_End"
                                            Label_Text="End time:"
                                            Input_Type='time'
                                            Value_Set_Enable={true}
                                            Value={Format_Time(Reservation.Time.End, "time")}
                                            onChange={Handle_Time_Change}
                                            Required={true}
                                        /> */}
                                        <UI_Input_Date
                                            id="Schedule_Date"
                                            Label_Text="Date:"
                                            Value={Format_Time(Reservation.Time.Start, "date")}
                                            PreventPast={true}
                                            onChange={Handle_Time_Change}
                                            Required={true}
                                        />
                                        {/* <UI_Input_Text
                                            id="Schedule_Date"
                                            Label_Text="Date:"
                                            Input_Type='date'
                                            Value_Set_Enable={true}
                                            Value={Format_Time(Reservation.Time.Start, "date")}
                                            PreventPast={true}
                                            onChange={Handle_Time_Change}
                                            Required={true}
                                        /> */}
                                    </UI_Form>
                                </div>




                                <UI_UpdatingStatus
                                    State={Conflicts.Soft.length + Conflicts.Hard.length > 0 ? "Bad" : "Good"}
                                    Loading={{
                                        Type: "Default",
                                        Title: "Checking for conflicts...",
                                        Text: "Please wait..."
                                    }}
                                    Good={{
                                        Type: "Default",
                                        Icon: "Default",
                                        Title: "No schedule conflicts",
                                        Text: "No schedule conflict detected. You can continue with your reservation."
                                    }}
                                    Bad={{
                                        Type: "Custom",
                                        Content: <div>
                                            <UI_Divider Text="Schedule conflicts" />
                                            {/* <p className='General_Paragraph'>
                                                <b>{Conflicts.Soft.length + Conflicts.Hard.length} schedule conflicts found.</b>
                                            </p> */}
                                            {Conflicts_BlockedHours.length > 0 ?
                                                <>
                                                    <p className='General_Paragraph' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                        <b>Your schedule conflicts with the room's set class hours.</b>
                                                        <br></br>
                                                        Your schedule may be rejected or rescheduled to a more appropriate time in order to not interrupt class hours.
                                                    </p>
                                                    <div className='General_List' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                        {Conflicts_BlockedHours.map((Item) => (
                                                            <UI_Card
                                                                Type="Schedule_List"
                                                                Figure={
                                                                    {
                                                                        Title: Item.Name,
                                                                        Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                        Chip: []
                                                                    }
                                                                }
                                                            />
                                                        ))}
                                                    </div>

                                                    <UI_Divider />
                                                </>
                                                :
                                                ""
                                            }
                                            <UI_StatGroup
                                                Items={[
                                                    Conflicts.Hard.length > 0 ? {
                                                        Key: "Hard conflicts",
                                                        Value: Conflicts.Hard.length,
                                                        Color: "Red"
                                                    } : undefined,
                                                    Conflicts_Soft.length > 0 ? {
                                                        Key: "Soft conflicts",
                                                        Value: Conflicts_Soft.length,
                                                        Color: "Orange"
                                                    } : undefined
                                                ]}
                                            />
                                            {Conflicts.Hard.length > 0 ?
                                                <p className='General_Paragraph' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                    <b>Hard conflicts</b> are schedules that have been fully approved. You can't submit your reservation at the same room and time as these schedules. Pick a different one.
                                                </p>
                                                :
                                                ""
                                            }
                                            {Conflicts_Soft.length > 0 ?
                                                <p className='General_Paragraph' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                    <b>Soft conflicts</b> are schedules that are still pending for approval. Given that there's no hard conflicts, you can still submit your reservation but it may be rejected in favor of these schedules.
                                                </p>
                                                :
                                                ""
                                            }


                                            {Conflicts.Hard.length > 0 ?
                                                <>
                                                    <div className='General_List' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                        {Conflicts.Hard.map((Item) => (
                                                            <UI_Card
                                                                Type="Schedule_List"
                                                                Figure={
                                                                    {
                                                                        Title: Item.Name,
                                                                        Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                        Chip: Status_Parse(Item)
                                                                    }
                                                                }
                                                            />
                                                        ))}
                                                    </div>

                                                </>

                                                :
                                                ""
                                            }
                                            {Conflicts_Soft.length > 0 ?
                                                <>
                                                    <div className='General_List' style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                        {Conflicts_Soft.map((Item) => (
                                                            <>
                                                                {!Item._id.includes("Blocked") ?
                                                                    <UI_Card
                                                                        Type="Schedule_List"
                                                                        Figure={
                                                                            {
                                                                                Title: Item.Name,
                                                                                Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                                Chip: Status_Parse(Item)
                                                                            }
                                                                        }
                                                                    />
                                                                    :
                                                                    ""
                                                                }
                                                            </>

                                                        ))}
                                                    </div>
                                                </>

                                                :
                                                ""
                                            }
                                        </div>
                                    }}
                                />
                                <div className='General_Split' Split="2" Orientation="Vertical">
                                    <div>

                                        <UI_UpdatingStatus
                                            State={Conflicts.Hard.length + Conflicts.Soft.length > 0 ? "Bad" : "Good"}
                                            Good={{
                                                Type: "Default",
                                                Icon: null,
                                                Title: "",
                                                Text: ""
                                            }}
                                            Bad={{
                                                Type: "Custom",
                                                Content: <>
                                                    <UI_Divider Text="Time slot suggestions" />
                                                    {/* <p className='General_Paragraph' style={{ marginBottom: "20px" }}>
                                                        Click a suggestion below to apply it to your reservation
                                                    </p> */}
                                                    <div className='General_List'>
                                                        {Conflict_Recommendation?.Time?.map((Item) => (
                                                            <UI_Card
                                                                Type="Schedule_List"
                                                                Figure={
                                                                    {
                                                                        Title: Time_Range_Parse(Item.Start, Item.End, "Time"),
                                                                        Main: Time_Parse(Item.Start, "Date"),
                                                                        Chip: []
                                                                    }
                                                                }
                                                            // onClick={() => Suggestion_Accept(Item, "Time")}
                                                            />
                                                        ))}
                                                    </div>
                                                </>
                                            }}
                                        />


                                    </div>
                                    <div>

                                        <UI_UpdatingStatus
                                            State={Conflicts.Hard.length + Conflicts.Soft.length > 0 ? "Bad" : "Good"}
                                            Good={{
                                                Type: "Default",
                                                Icon: null,
                                                Title: "",
                                                Text: ""
                                            }}
                                            Bad={{
                                                Type: "Custom",
                                                Content: <>
                                                    <UI_Divider Text="Room suggestions" />
                                                    <div className='General_List'>
                                                        {Conflict_Recommendation?.Room?.map((Item) => (
                                                            <UI_Card
                                                                Type="Schedule_List"
                                                                Figure={
                                                                    {
                                                                        Title: Item.Name,
                                                                        Main: "",
                                                                        Chip: []
                                                                    }
                                                                }
                                                            // onClick={() => Suggestion_Accept(Item, "Room")}
                                                            />
                                                        ))}
                                                    </div>
                                                </>
                                            }}
                                        />

                                    </div>
                                </div>
                            </div>




                        </>,
                        <>
                            <h3 className='General_Paragraph'>
                                Please confirm the details of your reservation. Once the request had been sent, it cannot be edited.
                            </h3>
                            <div className='General_Split' Split="2">
                                <div>
                                    <UI_Card Type="Panel_Info" Text="Activity name:" Figure={Reservation.Name} />
                                    <UI_Card Type="Panel_Info" Text="Activity description:" Figure={Reservation.Description} />
                                    <UI_Card Type="Panel_Info" Text="Activity type:" Figure={Reservation.Activity.Type} />
                                    <UI_Card Type="Panel_Info" Text="Requester name:" Figure={Reservation.Requester.Name} />
                                    <UI_Card Type="Panel_Info" Text="Requester type:" Figure={Reservation.Requester.Type} />
                                    <UI_Card Type="Panel_Info" Text="Requester email:" Figure={Reservation.Requester.Email} />
                                    <UI_Card Type="Panel_Info" Text="Attendees:" Figure={Reservation.Activity.Attendees.Names.length} />
                                    <UI_Card Type="Panel_Info" Text="Subject:" Figure={Reservation.Activity.Subject} />
                                </div>
                                <div>
                                    <UI_Card Type="Panel_Info" Text="Location:" Figure={Format_Location()} />
                                    <UI_Card
                                        Type="Panel_Info"
                                        Text="Time:"
                                        Figure={Time_Range_Parse(Reservation.Time.Start, Reservation.Time.End, "Time")}
                                    />
                                    <UI_Card
                                        Type="Panel_Info"
                                        Text="Date:"
                                        Figure={Time_Parse(Reservation.Time.Start, "Date")}
                                    />
                                </div>
                            </div>
                        </>,
                        <>
                            {Status_Saving == "InProgress" ?
                                <h2 className='General_Paragraph'>
                                    Sending request...
                                </h2>
                                :
                                Status_Saving == "Error" ?
                                    <h2 className='General_Paragraph'>
                                        An error has occured in your request.
                                    </h2>
                                    :
                                    ""
                            }
                        </>
                    ]}
                />


            </ui-subwindow-content>
            <ui-subwindow-controls>
                {Reservation_Step !== "Tab_Info_Send" || Status_Saving === "Error" ? 
                    <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Close}>
                        Cancel
                    </button>
                    :
                    ""
                }
                {Reservation_Step !== "Tab_Info_Send" ?
                    <>
                        
                        {Reservation_Step == "Tab_Info_Schedule" || Reservation_Step == "Tab_Info_Finalize" ?
                            <button className='General_Button Subwindow_Control' onClick={() => Handle_Step("Backward")}>
                                Previous
                            </button>
                            :
                            <div></div>
                        }
                        {Conflicts.Hard.length > 0 && Reservation_Step === "Tab_Info_Schedule" ?
                            <button className='General_Button Subwindow_Control'
                            // onClick={() => UI.Subwindows_Open("Window_ScheduleManagement_Conflict_Resolve_Standard")}
                            >
                                Resolve conflict to continue.
                            </button>
                            :
                            <button className='General_Button Subwindow_Control' Type='Primary' onClick={() => Handle_Step("Forward")}>
                                Next
                            </button>
                        }

                    </>

                    :
                    ""
                }

            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
